
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-03-17 16:02:20
 * @LastEditors: linxi
 * @LastEditTime: 2023-03-17 16:02:20
 */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../app/store'
import { sendAsync } from '../../app/applicationSlice'
import * as DT from '../../services/patientsManagement'

// 列表
export const getPatientsManagementList = createAsyncThunk<
  void,
  DT.PatientsManagementPrams,
  RootThunkApi<void>
>('clinic/getHealthList', async (params, api) => {
  return sendAsync(DT.patientsManagementList(params), api)
})

// echarts图表
export const getEchartsList = createAsyncThunk<
  void,
  DT.EchartsPrams,
  RootThunkApi<void>
>('clinic/getHealthList', async (params, api) => {
  return sendAsync(DT.echartsList(params), api)
})

